import { render, staticRenderFns } from "./BannerRain.vue?vue&type=template&id=4ca54f42&scoped=true"
import script from "./BannerRain.vue?vue&type=script&lang=js"
export * from "./BannerRain.vue?vue&type=script&lang=js"
import style0 from "./BannerRain.vue?vue&type=style&index=0&id=4ca54f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca54f42",
  null
  
)

export default component.exports